import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigService } from 'src/environments/app-config.service';
import {
  EmissionRegisterErrorAction,
  EmissionRegisterErrorViewModel,
} from '../emission-register-modal.model';

@Component({
  standalone: true,
  selector: 'app-modal-emission-register-error',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-emission-register-error.component.html',
  styleUrls: ['./modal-emission-register-error.component.scss'],
})
export class ModalEmissionRegisterErrorComponent {
  @Input() open = false;
  @Input() viewModel: EmissionRegisterErrorViewModel = {
    title: 'Erro!',
    description:
      'Não foi possível concluir a emissão dos créditos. Verifique os dados e tente novamente ou entre em contato com o suporte.',
  };

  @Output() action = new EventEmitter<EmissionRegisterErrorAction>();

  private supportUrl = '';

  constructor(appConfig: AppConfigService) {
    this.supportUrl = appConfig.config?.urlSuporteB3 ?? 'https://atendimento.b3.com.br/atendeb3';
  }

  onModalDismiss(): void {
    this.action.emit('dismiss');
  }

  onRetry(): void {
    this.action.emit('retry');
  }

  onSupport(): void {
    if (this.supportUrl) {
      window.open(this.supportUrl, '_blank', 'noopener,noreferrer');
    }
    this.action.emit('support');
  }
}
